import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request';
import { SisifoCenter } from '@app/core/users';
import { firstValueFrom } from 'rxjs';

let hospitalsCache: SisifoHospital[] = [];

// {
//     "statKrz": "ATHIS",
//     "statName": "ATHIS"
// }
export type SisifoService = {
  statKrz: string;
  statName: string;
};

// {
//     "anstaltNr": "ATHIS",
//     "anstName": "Prog Sintrom"
// },
export type SisifoHospital = {
  anstaltNr: string;
  anstName: string;
  services?: SisifoService[];
};

@Injectable({
  providedIn: 'root',
})
export class CenterService {
  constructor(private request: RequestService) {}

  async getCenters(): Promise<SisifoCenter[]> {
    return await firstValueFrom(
      this.request.get<SisifoCenter[]>('/api/sisifo/centers')
    );
  }

  async getCenter(centerId: number): Promise<SisifoCenter> {
    return await firstValueFrom(
      this.request.get<SisifoCenter>(`/api/sisifo/centers/${centerId}`)
    );
  }

  async getHospitals(): Promise<SisifoHospital[]> {
    if (hospitalsCache.length > 0) {
      return hospitalsCache;
    }
    const hospitals = await firstValueFrom(
      this.request.get<SisifoHospital[]>('/api/sisifo/hospitals')
    );
    hospitalsCache = hospitals;
    return hospitals;
  }

  async getHospital(hospitalId: string): Promise<SisifoHospital> {
    const cachedHospital = hospitalsCache.find(h => h.anstaltNr === hospitalId);
    if (cachedHospital) {
      return cachedHospital;
    }
    return await firstValueFrom(
      this.request.get<SisifoHospital>(`/api/sisifo/hospitals/${hospitalId}`)
    );
  }

  async create(center: SisifoCenter): Promise<any> {
    return await firstValueFrom(
      this.request.post<any>('/api/sisifo/centers', center)
    );
  }

  async update(center: SisifoCenter): Promise<any> {
    return await firstValueFrom(
      this.request.put<any>(`/api/sisifo/centers/${center.centroId}`, center)
    );
  }

  async delete(centerId: number): Promise<void> {
    await firstValueFrom(
      this.request.delete(`/api/sisifo/centers/${centerId}`)
    );
  }

  async deleteMultiple(centerIds: number[]): Promise<void> {
    const promises = centerIds.map((id) =>
      firstValueFrom(this.request.delete(`/api/sisifo/centers/${id}`))
    );
    await Promise.all(promises);
  }
}
